import { IAutomationAppComponent } from "../../types";
import { schema, schemaTemperature, schemaHumidity, schemaSupplyPressure, schemaExhaustPressure } from "./types";
import { OverviewPanel, OperatorPanel } from '.';
import { ListPanel } from "./ListPanel";
import { TiSortNumerically } from "react-icons/ti";


export const App: IAutomationAppComponent = {
    schema: schema,
    supportsProcessPanel: false,
    Icon: TiSortNumerically,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    ListPanel: ListPanel,
    createConfig: {
        group: 'Functions',
        name: "Analog setpoint",
        description: "Analog setpoint",
        panel: OverviewPanel,
        defaultState: { value: 60, dimension: '#' },
        defaultProperties: []
    },
}
export const AppTemp: IAutomationAppComponent = {
    schema: schemaTemperature,
    supportsProcessPanel: false,
    Icon: TiSortNumerically,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    ListPanel: ListPanel,
    createConfig: {
        group: 'Functions',
        name: "Temperature setpoint",
        description: "Temperature setpoint",
        panel: OverviewPanel,
        defaultState: { value: 22.3, dimension: '°C' },
        defaultProperties: []
    },
}

export const AppHum: IAutomationAppComponent = {
    schema: schemaHumidity,
    supportsProcessPanel: false,
    Icon: TiSortNumerically,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    ListPanel: ListPanel,
    createConfig: {
        group: 'Functions',
        name: "Humidity setpoint",
        description: "Humidity setpoint",
        panel: OverviewPanel,
        defaultState: { value: 45, dimension: '%' },
        defaultProperties: []
    },
}
export const AppSupPress: IAutomationAppComponent = {
    schema: schemaSupplyPressure,
    supportsProcessPanel: false,
    Icon: TiSortNumerically,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    ListPanel: ListPanel,
    createConfig: {
        group: 'Functions',
        name: "Supply pressure setpoint",
        description: "Supply pressure setpoint",
        panel: OverviewPanel,
        defaultState: { value: 250, dimension: 'pa' },
        defaultProperties: []
    },
}
export const AppExPress: IAutomationAppComponent = {
    schema: schemaExhaustPressure,
    supportsProcessPanel: false,
    Icon: TiSortNumerically,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    ListPanel: ListPanel,
    createConfig: {
        group: 'Functions',
        name: "Exhaust pressure setpoint",
        description: "Exhaust pressure setpoint",
        panel: OverviewPanel,
        defaultState: { value: 250, dimension: 'pa' },
        defaultProperties: []
    },
}

